import { Injectable } from '@angular/core';
import { CartolaService } from './cartola.service';

/** Cuenta especial que la cola asigna siempre al mismo cliente (fábrica rosa). */
const CUENTA_FABRICA_ROSA = '70969647';

/** Cartola sin asignar, como la devuelve "Transacciones sin asignar". */
export interface DepositoRetenido {
  cartolaId: number;
  codigoTransferencia: string;
  moSaldoAbono: number;
  rutOrigen: string;
  nombreOrigen?: string;
  fechaRecepcion?: string;
  hora?: string;
  cuentaCorriente?: string;
  usuarioId?: number | null;
  createdAt?: string;
  [campo: string]: any;
}

/** Documento comparable: sin puntos, guion ni espacios, en mayúsculas y sin ceros a la izquierda. */
const normalizar = (valor?: string | null): string =>
  String(valor ?? '')
    .replace(/[.\-\s]/g, '')
    .toUpperCase()
    .replace(/^0+/, '');

/**
 * Depósitos retenidos (cartolas sin asignar) de un documento, para ofrecer
 * asignarlos cuando compliance aprueba a su dueño (A1). Usa el mismo listado
 * que "Transacciones sin asignar", que filtra el RUT con LIKE, y acá se queda
 * solo con las coincidencias exactas desde la fecha indicada.
 */
@Injectable({ providedIn: 'root' })
export class DepositosRetenidosService {
  constructor(private cartolas: CartolaService) {}

  async buscar(
    documento: string | null | undefined,
    desde?: string | Date | null,
  ): Promise<DepositoRetenido[]> {
    const doc = normalizar(documento);
    if (doc.length < 2) return [];
    const res = await this.cartolas.getTransaccionesRezagadas({ rut: doc }, 1, 100);
    const filas: DepositoRetenido[] = Array.isArray(res?.query) ? res.query : [];
    const limite = desde ? new Date(desde).getTime() : NaN;
    return filas.filter((c) => {
      if (c.usuarioId !== null && c.usuarioId !== undefined) return false;
      if (normalizar(c.rutOrigen) !== doc) return false;
      if (!(Number(c.moSaldoAbono) > 0)) return false;
      if (c.cuentaCorriente === CUENTA_FABRICA_ROSA) return false;
      if (Number.isFinite(limite) && c.createdAt && new Date(c.createdAt).getTime() < limite) {
        return false;
      }
      return true;
    });
  }
}
